import React from "react";

/* Monoline 16×16 icon set for the Terminal redesign.
   Matches the prototype `<BloxIcon name=... />` API. Coexists with
   the proprietary GeoIcon set — GeoIcon is for brand surfaces (login,
   marketing chrome), BloxIcon is for the Bloomberg-style terminal
   action chips, hover-revealed contextual actions, and quick-action
   strips where stroke weight uniformity matters more than the
   diamond-motif brand mark. */

const ICONS = {
  move:    "M2 8 L14 8 M10 4 L14 8 L10 12",
  convert: "M3 6 L13 6 L10 3 M13 10 L3 10 L6 13",
  deploy:  "M4 12 L12 4 M6 4 L12 4 L12 10",
  borrow:  "M8 2 L8 12 M4 8 L8 12 L12 8 M2 14 L14 14",
  lend:    "M8 14 L8 4 M4 8 L8 4 L12 8 M2 2 L14 2",
  repay:   "M13 6 A6 6 0 1 0 8 14 M13 3 L13 6 L10 6",
  sweep:   "M3 13 L13 3 M9 3 L13 3 L13 7 M3 13 L7 11 M3 13 L5 9",
  yield:   "M2 12 L6 8 L9 10 L14 4 M11 4 L14 4 L14 7",
  send:    "M2 8 L14 8 M10 4 L14 8 L10 12",
  receive: "M14 8 L2 8 M6 4 L2 8 L6 12",
  bulk:    "M2 4 L14 4 M2 8 L14 8 M2 12 L14 12 M2 4 L2 12",
  schedule:"M3 5 L13 5 L13 13 L3 13 Z M3 8 L13 8 M6 3 L6 6 M10 3 L10 6",
  vendors: "M2 13 L2 6 L8 2 L14 6 L14 13 M6 13 L6 9 L10 9 L10 13",
  p2p:     "M5 7 A2 2 0 1 1 5 6.99 M11 7 A2 2 0 1 1 11 6.99 M2 13 C2 11 4 10 5 10 C6 10 8 11 8 13 M8 13 C8 11 10 10 11 10 C12 10 14 11 14 13",
  alert:   "M8 2 L14 13 L2 13 Z M8 6 L8 10 M8 12 L8 12.01",
  search:  "M7 7 m -4 0 a 4 4 0 1 0 8 0 a 4 4 0 1 0 -8 0 M10 10 L13 13",
  globe:   "M8 2 A6 6 0 1 0 8 14 A6 6 0 1 0 8 2 M2 8 L14 8 M8 2 C5 5 5 11 8 14 M8 2 C11 5 11 11 8 14",
  chart:   "M2 13 L6 9 L9 11 L14 5",
  vault:   "M3 4 L13 4 L13 13 L3 13 Z M6 8 L10 8 M8 6 L8 10",
  bank:    "M2 6 L8 2 L14 6 L14 7 L2 7 Z M3 8 L3 12 M6 8 L6 12 M10 8 L10 12 M13 8 L13 12 M2 13 L14 13",
  wire:    "M2 8 L14 8 M10 4 L14 8 L10 12",
  shield:  "M8 2 L13 4 L13 9 C13 12 8 14 8 14 C8 14 3 12 3 9 L3 4 Z",
  card:    "M2 5 L14 5 L14 12 L2 12 Z M2 8 L14 8 M5 10 L8 10",
  cog:     "M8 2 L9 4 L11 4 L11 6 L13 7 L13 9 L11 10 L11 12 L9 12 L8 14 L7 12 L5 12 L5 10 L3 9 L3 7 L5 6 L5 4 L7 4 Z M8 6 A2 2 0 1 1 7.99 6",
};

export const BLOX_ICON_NAMES = Object.keys(ICONS);

export default function BloxIcon({
  name,
  size = 14,
  stroke = 1.4,
  color = "currentColor",
  style,
  title,
}) {
  const d = ICONS[name];
  if (!d) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke={color}
      strokeWidth={stroke}
      strokeLinecap="square"
      strokeLinejoin="miter"
      style={{ flexShrink: 0, ...style }}
      role={title ? "img" : "presentation"}
      aria-label={title || undefined}
    >
      {title ? <title>{title}</title> : null}
      <path d={d} />
    </svg>
  );
}
